import { UniversalNavLinkType } from 'src/universal-nav/constants';

export const fallbackSidebarLinks: UniversalNavLinkType[] = [
  {
    href: '/app/dashboard',
    icon: {
      selected: 'navDashboardFill',
      unselected: 'navDashboard',
    },
    text: 'Dashboard',
  },
  {
    href: '/app/zaps',
    icon: {
      selected: 'miscBoltAltFill',
      unselected: 'miscBoltAlt',
    },
    text: 'Zaps',
  },
  {
    href: '/app/transfers',
    icon: {
      selected: 'arrowConnect',
      unselected: 'arrowConnect',
    },
    text: 'Transfers',
  },
  {
    href: `https://tables.zapier.com/app/tables?utm_campaign=zpr-gbl-nua-evr-product_sidenav-prd&utm_medium=product&utm_source=zapier`,
    icon: {
      selected: 'navTableFill',
      unselected: 'navTable',
    },
    text: 'Tables',
  },
  {
    href: `https://interfaces.zapier.com/interfaces?utm_campaign=zpr-gbl-nua-evr-product_sidenav-prd&utm_medium=product&utm_source=zapier/`,
    icon: {
      selected: 'navInterfacesFill',
      unselected: 'navInterfaces',
    },
    text: 'Interfaces (beta)',
  },
  {
    href: '/app/connections',
    icon: {
      selected: 'navAppsFill',
      unselected: 'navApps',
    },
    text: 'Apps',
  },
  {
    href: '/app/history',
    icon: { selected: 'miscClockFill', unselected: 'miscClock' },
    text: 'Zap History',
  },
  {
    href: '/help',
    icon: { selected: 'navHelpFill', unselected: 'navHelp' },
    text: 'Get Help',
  },
];
